export enum ItemFieldsEnum {
  id = 'id',
  archived = 'archived',
}
